module.exports = __webpack_public_path__ + "img/step03_c_stand_basic_left_screws.f2138052.png";